const AuthReducer = (state, action) => {
  switch (action.type) {
    case 'RESET':
      return {
        ...state,
        message: ''
      }
    case 'LOGIN_START':
      return {
        user: null,
        isFetching: true,
        error: false
      }
    case 'CREATE_FAILURE':
      return {
        ...state,
        message: action.payload
      }
    case 'CREATE_SUCCESS':
      return {
        ...state,
        message: action.payload
      }
    case 'UPDATE_FAILURE':
      return {
        ...state,
        message: action.payload
      }
    case 'UPLOAD_FAILURE':
      return {
        ...state,
        message: action.payload
      }
    case 'UPLOAD_SUCCESS':
      return {
        ...state,
        message: action.payload
      }
    case 'UPDATE_SUCCESS':
      return {
        ...state,
        data: action.payload,
        message: action.message
      }
    case 'GET_USER_FAILURE':
      return {
        ...state,
        message: action.payload
      }

    case 'GET_USER_SUCCESS':
      return {
        ...state,
        data: action.payload,
        message: action.message
      }
    case 'LOGIN_SUCCESS':
      return {
        user: action.payload,
        isFetching: false,
        error: false
      }
    case 'LOGIN_FAILURE':
      return {
        user: null,
        isFetching: false,
        error: true,
        message: action.payload
      }
    case 'LOGOUT':
      localStorage.clear()
      return {
        user: null,
        isFetching: false,
        error: false
      }
    default:
      return { ...state }
  }
}

export default AuthReducer
